import styled, { css } from 'styled-components';
import { Theme, Box } from '@bechtel/gds';
import { CommodityStatusCode } from '@bechtel/types';

interface WeldoutItemProps {
  status?: string;
  theme: Theme;
  totalWelds: number;
  isAssigned?: boolean;
}

const getAssignedColor = (props: WeldoutItemProps) => {
  return props.isAssigned
    ? css`
        background-color: ${props.theme.colors.bechtel.blue[500]};
        border: 1px solid ${props.theme.colors.bechtel.blue[500]};
      `
    : css`
        background-color: transparent;
        border: 1px solid ${props.theme.colors.grey[500]};
      `;
};

const getBackgroundColor = (props: WeldoutItemProps) => {
  switch (props.status) {
    case CommodityStatusCode.VT_APPROVED:
      return css`
        background-color: ${props.theme.colors.green[500]};
        border: 1px solid ${props.theme.colors.green[500]};
      `;
    case CommodityStatusCode.CLAIMED:
    case CommodityStatusCode.FITUP_INSPECTION:
      return css`
        background-color: ${props.theme.colors.orange['000']};
        border: 1px solid ${props.theme.colors.orange['000']};
      `;
    case CommodityStatusCode.BLOCKED:
      return css`
        background-color: ${props.theme.colors.red[500]};
        border: 1px solid ${props.theme.colors.red[500]};
      `;
    case CommodityStatusCode.VT_SENT_BACK:
    case CommodityStatusCode.SENT_BACK_TO_PIPING:
      return css`
        background-color: ${props.theme.colors.purple[500]};
        border: 1px solid ${props.theme.colors.purple[500]};
      `;
    case CommodityStatusCode.FITUP_REQUESTED:
      return css`
        background-color: ${props.theme.colors.yellow[300]};
        border: 1px solid ${props.theme.colors.yellow[300]};
      `;
    case CommodityStatusCode.READY_TO_WELD:
      return getAssignedColor(props);
    default:
      return getAssignedColor(props);
  }
};

export const WeldStatusItemStyled = styled(Box)<WeldoutItemProps>`
  width: ${(props) => `calc(100% / ${props.totalWelds})`};
  ${({ theme }) => css`
    max-width: ${theme.spacings[600]};
    height: ${theme.spacings[400]};
    border-radius: ${theme.spacings[200]};
    margin-right: ${theme.spacings[200]};
  `}
  ${getBackgroundColor}
`;

export const WeldoutsCompleteLabel = styled.div`
  color: ${({ theme }) => theme.colors.grey['600']};
  font-size: ${({ theme }) => theme.fontSizes['300']};
`;
